import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    showEntutiveLogo:false,
    quoteProgress: 0,
    showQuotes: false,
    contactPhoneNumber:"18554825001",
    contactButton:"MIB",
    profile:"MIB"
};

export const uiSlice = createSlice({
    name: 'ui',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
      setQuoteProgress: (state,action) => {
        state.quoteProgress = action.payload.progress;
      },
      setShowQuotes: (state,action) => {
        state.showQuotes = action.payload.show;
      },
      setEntutiveLogoShow: (state,action) =>{
        state.showEntutiveLogo = action.payload.show
      },
      setContactButton: (state,action) =>{
        state.contactPhoneNumber = action.payload.phoneNumber
        state.contactButton = action.payload.button
      },
      setProfile: (state,action) =>{
        state.profile = action.payload.profile      
      }
    }
});

export const { setQuoteProgress,setShowQuotes,setEntutiveLogoShow,setContactButton,setProfile } = uiSlice.actions;

export default uiSlice.reducer;